import { InjectionToken } from '@angular/core';
import { Environment } from '@sc/data-access-models';

export const ENV_CONFIG = new InjectionToken<Environment>('env');
